import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigService } from 'src/app/shared/services/config.service';
import { MeService } from 'src/app/shared/services/me.service';
@Component({
  selector: 'app-mail-type-modal',
  templateUrl: './mail-type-modal.component.html',
  styleUrls: ['./mail-type-modal.component.scss'],
})
export class MailTypeModalComponent implements OnInit {
  public mailType: string;
  public canCreateEntrant = true;
  public canCreateSortant = true;
  public canCreateInterne = true;
  public canCreateEmail = false;

  constructor(
    public router: Router,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private spinner: NgxSpinnerService,
    private configService: ConfigService,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.getConfig();
  }

  getConfig(): void {
    this.configService.fetchConfig().subscribe({
      next: (res) => {
        this.canCreateEmail = res.connecteurs.isExchangeConfigured;
        this.getRight();
      },
    });
  }

  getRight(): void {
    this.meService.getUserInfo().subscribe({
      next: (res) => {
        this.canCreateEntrant = res.encodageNouveauEntrant;
        this.canCreateSortant = res.encodageNouveauSortant;
        this.spinner.hide();
      },
    });
  }

  public close(value?: string): void {
    if (value) {
      this.ref.close(value);
    } else {
      this.ref.close();
    }
  }

  openExchange(): void {
    this.router.navigateByUrl('/private/ic/courriers-exchange');
    this.ref.close();
  }
}
